import {
  BlockContentValue,
  SectionContainer,
  SectionTitle,
  SectionTitleBody,
  SectionTitleHeading
} from "@silversea-ssc/ui-components-react";
import React from "react";
import * as styles from "./WhySilverseaSection.module.scss";
import { BlockContent } from "components/BlockContent";
import TextBox from "components/TextBox/TextBox";

type Props = {
  id: string;
  title: string | undefined;
  content: BlockContentValue | undefined;
  cruiseFareInclusions?: BlockContentValue;
  cruiseFareInclusionsFootnotes?: BlockContentValue;
};

const WhySilverseaSection: React.FC<Props> = ({
  id,
  title,
  content,
  cruiseFareInclusions,
  cruiseFareInclusionsFootnotes
}) => {
  return (
    <SectionContainer
      dataContentName="why_silversea"
      spacingTop="regular"
      spacingBottom="compact"
      backgroundColor="neutral05"
      id={id}
    >
      <SectionTitle variant="wide">
        <SectionTitleHeading>{title}</SectionTitleHeading>
        <SectionTitleBody>
          <TextBox content={content} fontSize="inherit" />
        </SectionTitleBody>
      </SectionTitle>

      <div className={styles.list}>
        <BlockContent value={cruiseFareInclusions}></BlockContent>
      </div>
      <div className={styles.disclaimer}>
        <BlockContent value={cruiseFareInclusionsFootnotes} />
      </div>
    </SectionContainer>
  );
};

export default WhySilverseaSection;
